import * as z from "zod";
import { WithPhoneNumber } from "@/lib/schemas";

export const ClaimFormSchema = z
  .object({
    firstName: z
      .string()
      .min(1, "First name is required")
      .max(255, "First name is too long")
      .regex(
        /^[a-zA-ZÀ-ÿ' -]+$/,
        "First name can only contain letters, spaces, hyphens, and apostrophes"
      ),
    lastName: z
      .string()
      .min(1, "Last name is required")
      .max(255, "Last name is too long")
      .regex(
        /^[a-zA-ZÀ-ÿ' -]+$/,
        "Last name can only contain letters, spaces, hyphens, and apostrophes"
      ),
    emailAddress: z.email("Invalid email address"),
  })
  .extend(WithPhoneNumber.shape);

export const PhoneLoginFormSchema = WithPhoneNumber;

export const EmailLoginFormSchema = z.object({
  email: z.email({ message: "Please enter a valid email address" }),
});
